var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifyAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 133,
    viewBox: "0 0 157 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 24.5005,
    width: 137,
    height: 67,
    rx: 7.5,
    stroke: "#0BC5EA",
    strokeDasharray: "4 4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0197,
    y: 42.9119,
    width: 94.487,
    height: 60.4415,
    fill: "#A0AEC0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 37.8923,
    width: 94.487,
    height: 60.4415,
    fill: "#EDF2F7",
    stroke: "#A0AEC0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3726 74.2849L19 37.8927L113.745 37.8928L66.3726 74.2849Z",
    fill: "#EDF2F7",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3726 1.50049L19 37.8927L113.745 37.8926L66.3726 1.50049Z",
    fill: "#EDF2F7",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7788 22.5149L73.715 18.8534L73.6279 24.2287L73.6048 25.6529L74.9521 25.1908L80.0374 23.4469L77.7714 28.322L77.1711 29.6136L78.5899 29.7395L83.9448 30.2147L79.8919 33.7467L78.818 34.6825L80.063 35.3746L84.7617 37.9867L79.6226 39.5649L78.2609 39.983L79.1167 41.1217L82.3468 45.4191L77.0101 44.7705L75.5961 44.5987L75.9148 45.987L77.1176 51.2267L72.5061 48.4635L71.2842 47.7314L71.0107 49.1293L69.9784 54.4052L66.8894 50.0053L66.071 48.8395L65.2525 50.0053L62.1636 54.4052L61.1312 49.1293L60.8577 47.7314L59.6359 48.4635L55.0243 51.2267L56.2272 45.987L56.5459 44.5987L55.1319 44.7705L49.7952 45.4191L53.0252 41.1217L53.881 39.983L52.5194 39.5649L47.3803 37.9867L52.079 35.3746L53.3239 34.6825L52.2501 33.7467L48.1972 30.2147L53.5521 29.7395L54.9709 29.6136L54.3705 28.322L52.1046 23.4469L57.1898 25.1908L58.5372 25.6529L58.5141 24.2287L58.4269 18.8534L62.3632 22.5149L63.4061 23.4851L63.9643 22.1746L66.071 17.2286L68.1777 22.1746L68.7358 23.4851L69.7788 22.5149Z",
    fill: "#A0AEC0",
    stroke: "#A0AEC0",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9558 36.6932L63.5528 41.3587L73.6309 31.1306",
    stroke: "#EDF2F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3726 74.2848L19 37.8926L19 98.1277L66.3726 74.2848Z",
    fill: "#EDF2F7",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0588 74.2848L113.431 37.8926L113.431 98.1277L66.0588 74.2848Z",
    fill: "#EDF2F7",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3725 61.7356L113.745 98.1278H19L66.3725 61.7356Z",
    fill: "#EDF2F7",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.566 108.241L153.171 101.971L154.438 101.52L153.642 100.437L150.818 96.5941L150.688 96.4164L150.494 96.3101L97.4748 67.1337L95.4315 66.0093L96.0257 68.2645L111.398 126.617L111.498 126.995L111.826 127.205L116.29 130.061L117.119 130.591L117.663 129.771L127.914 114.289L135.055 125.344L135.129 125.46L135.232 125.551L140.547 130.249L141.17 130.8L141.826 130.287L147.827 125.589L148.612 124.974L147.999 124.187L135.566 108.241Z",
    fill: "#A0AEC0",
    stroke: "#A0AEC0",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130.546 103.221L148.152 96.9515L150.245 96.2059L148.299 95.1336L97.4752 67.1339L95.4305 66.0074L96.0257 68.2647L110.843 124.454L111.411 126.611L112.643 124.751L122.971 109.153L135.401 125.095L136.017 125.885L136.806 125.268L142.807 120.569L143.593 119.954L142.979 119.167L130.546 103.221Z",
    fill: "#EDF2F7",
    stroke: "#A0AEC0",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyAccount);
export default __webpack_public_path__ + "static/media/verify-account.4d4fcb3df1292695a00320556a5f8b1b.svg";
export { ForwardRef as ReactComponent };